/*
 * File: input-time.ts
 * File Created: 2024-09-13 09:29:09
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified:
 * Modified By:
 * -----
 */

import { Component } from "vue-property-decorator";
import InputDate from "../input-date/input-date";

@Component
export default class InputTime extends InputDate {}
